<template>
	<div v-if="isSelected" class="has-text-white wrapper">
		<div class="input-wrapper mx-auto px-10 is-relative">
			<input 
				class='custom-input no-spin-buttons is-size-6-mobile is-size-5-tablet medium-text pb-1 has-text-centered has-background-transparent has-text-white is-shadowless'
				type='number'
				:min="11"
				:max="999"
				v-model="leadsAmount"
				placeholder="Enter a number"
				@click.stop=""
				@input="debounce"
				required
			/>
			<div class='input-underline is-overlay'></div>
		</div>
		<p class="is-size-6-mobile is-size-5-tablet">for</p>
		<p class="is-size-5-mobile is-size-4-tablet medium-text">${{ plan.price || '---' }}</p>
		<p class="medium-text">(${{!(plan.price && plan.price_per_lead) ? '--' : plan.price_per_lead}}/lead)</p>
	</div>
	<span v-else class="is-size-5-mobile is-size-4-tablet medium-text is-underlined has-text-primary">10+ Verified Jobs?</span>	
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { debounce } from 'lodash'
import { STATE_MODULES } from "@/store/state-modules";
import { LeadsMutations } from "@/store/modules/leads/mutations";
import { LeadsActions } from "@/store/modules/leads/actions";
import { LeadsPlanContentMixin, modelValueGetSetMixin } from "@/utils/mixins";

export default defineComponent({
	mixins: [modelValueGetSetMixin, LeadsPlanContentMixin],
	data () { 
		return {
			leadsAmount: null,
			debounce: debounce((e) => this.onInputChange(e), 1500)
		}
	},
	methods: { 
		onInputChange (event: any) {
			const value = parseInt(this.leadsAmount || '0', 10);
			if (!event.target.validity.valid) { 
				this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_CUSTOM_PLAN}`, {});
				this.value = 'Please enter a number between 11 and 999';
				return;
			}
			
			this.$store.dispatch(`${STATE_MODULES.LEADS}/${LeadsActions.CALCULATE_DYNAMIC_PLAN_PRICE}`, value);	
		}
	},
	watch: {
		isSelected () {
			this.leadsAmount = null;
		}
	}
})
</script>

<style scoped>
	.wrapper { 
		width: 100%;
	}
	
	.input-wrapper {
		width: 85%;
		max-width: 200px;
	}
    .custom-input { 
		border: none;
		width: 100%;
	}

	.custom-input::placeholder { 
		color: #EBEBEB;
	}

	.custom-input:focus { 
		outline: none;
	}

	.input-underline { 
		border: 1.4px solid #EBEBEB;
		border-top: none;
		width: 100%;
		left: 50%;
		top: 80%;
		transform: translate(-50%);
	}
</style>
